<template>
  <div class="p-16 bg-surface-modal">
    <div class="flex flex-col">
      <p
        v-if="
          cardData?.payment?.MonthlyPrice !==
          cardData?.payment?.RegularMonthlyPrice
        "
        class="strike-through w-fit heading-xxs text-text-on-highlight"
      >
        {{ cardData?.payment?.RegularMonthlyPrice }}
      </p>
      <p class="heading-xs text-text-on-highlight" aria-hidden="true">
        {{ cardData?.payment?.MonthlyPrice }} kr/mån
      </p>
      <p class="sr-only">
        {{ cardData?.payment?.MonthlyPrice }} kronor i månaden.
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  cardData?: ProductCard;
}

defineProps<Props>();
</script>

<style scoped lang="scss">
.strike-through {
  &:before {
    background: linear-gradient(
      to left top,
      transparent 45.5%,
      var(--text-on-highlight) 47.5%,
      var(--text-on-highlight) 52.5%,
      transparent 54.5%
    ) !important;
  }
}
</style>
